import * as React from "react";

import styles from "./ApplicationDetailsEmpty.module.scss";

import { ReactComponent as DirectboxReceiveIcon } from "assets/images/svg/directbox-receive.svg";
import { AppLoader } from "components/AppLoader";

interface Props {
  loading: boolean;
}
export const ApplicationDetailsEmpty: React.FC<Props> = ({ loading }) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <DirectboxReceiveIcon />
      </div>
      {loading ? (
        <AppLoader />
      ) : (
        <>
          <div className={styles.title}>Заявка пока не выбрана</div>
          <div className={styles.description}>
            Нажмите на одну из заявок, чтобы узнать подробности
          </div>
        </>
      )}
    </div>
  );
};
